






import Vue from "vue";
interface ButtonGroupState {
  value: number | undefined;
  update: (value: number) => void;
}

interface Provide {
  getButtonGroupState: () => ButtonGroupState;
}

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: false
    }
  },
  provide(): Provide {
    return {
      getButtonGroupState: this.buttonGroupState
    };
  },

  methods: {
    buttonGroupState(): ButtonGroupState {
      return {
        value: this.value,
        update: this.updateIndex
      };
    },
    updateIndex(value: number) {
      this.$emit("selected", value);
    }
  }
});
